import { render } from "./SongItem.vue?vue&type=template&id=389bcfe4"
import script from "./SongItem.vue?vue&type=script&lang=js"
export * from "./SongItem.vue?vue&type=script&lang=js"
script.render = render

export default script